export default __webpack_public_path__ + "static/media/white.f4a51aa2.png";